
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    this.setDate(date.getDate() + days);
}

var deliveryHandler = { 

    timer: false,

    bind: function(){
        clearTimeout(deliveryHandler.timer);
        if($("#delivery").length){
            deliveryHandler.calculate();
            deliveryHandler.timer = setTimeout(function(){
                deliveryHandler.bind();
            }, 60000);
        }
    },

    specialDates: [
        {
            "after": "2025-05-23T15:00:00.000Z",
            "before": "2025-05-27T15:00:00.000Z",
            "delivery": "2025-05-28T11:00:00.000Z"
        }
    ],

    getSpecialDate(currentDate){
        let currentTime = currentDate.getTime();
        for(let specialDate of this.specialDates){
            try {
                let afterTime = new Date(specialDate.after).getTime();
                let beforeTime = new Date(specialDate.before).getTime();

                if(currentTime >= afterTime && currentTime <= beforeTime){
                    return {
                        "cutoff": specialDate.before,
                        "delivery": specialDate.delivery
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
        
        return false;
    },

    calculate: function(test = false, testYear = false, testMonth = false, testDay = false, testHour = false, testMinutes = false, testSeconds = false){

        try {
            
            var todaysDateStr = new Date().toLocaleString("en-US", {timeZone: "Europe/London"});
            var todaysDate = new Date(todaysDateStr);
            var cutOffDateStr = new Date().toLocaleString("en-US", {timeZone: "Europe/London"});
            var cutOff = new Date(cutOffDateStr);
            
            if(isNaN(todaysDate.getTime())){
                throw "Todays Date Is Invalid";
            }

            if(test == true){
                // Remove Automatic Refresh
                clearTimeout(deliveryHandler.timer);
                if(testYear !== false){
                    todaysDate = new Date(parseInt(testYear), parseInt(testMonth) - 1, parseInt(testDay), parseInt(testHour), parseInt(testMinutes), parseInt(testSeconds));
                    cutOff = new Date(parseInt(testYear), parseInt(testMonth) - 1, parseInt(testDay), parseInt(testHour), parseInt(testMinutes), parseInt(testSeconds));
                } else {
                    todaysDate = new Date(parseInt($("#deliverytest-year").val()), parseInt($("#deliverytest-month").val()) - 1, parseInt($("#deliverytest-day").val()), parseInt($("#deliverytest-hours").val()), parseInt($("#deliverytest-minutes").val()), parseInt($("#deliverytest-seconds").val()));
                    cutOff = new Date(parseInt($("#deliverytest-year").val()), parseInt($("#deliverytest-month").val()) - 1, parseInt($("#deliverytest-day").val()), parseInt($("#deliverytest-hours").val()), parseInt($("#deliverytest-minutes").val()), parseInt($("#deliverytest-seconds").val()));
                }

                console.log("DeliveryHandler > Date Simulated");
                console.log(todaysDate);
            }

            var currentMinute = todaysDate.getMinutes();
            var currentHour = todaysDate.getHours();
            var currentDay = todaysDate.getDate();
            var currentMonth = parseInt(todaysDate.getMonth()) + 1;
            var currentYear = todaysDate.getFullYear();

            
            // If after 4pm, add a day to cutOff
            if(cutOff.getHours()>=16){
                cutOff.addDays(1);
            }

            // If at the weekend, push cutOff date to Monday
            while(cutOff.getDay()==0||cutOff.getDay()==6){
                cutOff.addDays(1);
            }

            // Set the cutOff time to 4pm
            cutOff.setHours(16);
            cutOff.setMinutes(0);
            cutOff.setSeconds(0);

            // Special Delivery dates e.g. Christmas
            // Define a new cut-off date

            var specialDate = this.getSpecialDate(todaysDate);

            if(specialDate){
                cutOff = new Date(specialDate.cutoff);
            }

            // Determine Remaining Days, hours and minutes
            var remaining = cutOff.getTime()-todaysDate.getTime();
            var remaining_hours = Math.floor(remaining/(1*60*60*1000));
            var remaining_minutes = Math.floor((remaining-remaining_hours*(1*60*60*1000))/(1*60*1000));

            // Determine the Delivery Date
            var delivery = new Date(cutOff.toLocaleString("en-US", {timeZone: "Europe/London"}));
            
            // Special Delivery dates e.g. Christmas
            // Define a new delivery date
            if(specialDate){

                console.log("DeliveryHandler > Special Delivery Date Met");
                delivery = new Date(specialDate.delivery);
            
            } else {
                // Push delivery to following day excluding weekends
                delivery.addDays(1);

                if(delivery.getDay() == 0){
                    while(delivery.getDay() == 0){
                        delivery.addDays(1);
                    } 
                }                          
            }
        

            var deliveryDay = delivery.getDay();
        
            // Determine full Delivery Day to attach to order
            Number.prototype.toOrdinal = function(){
                var n = this % 100;
                var suff = ["th", "st", "nd", "rd", "th"]; // suff for suffix
                var ord= n<21?(n<4 ? suff[n]:suff[0]): (n%10>4 ? suff[0] : suff[n%10]);
                return this + ord;
            }

            var mths = {1:'January', 2:'February', 3:'March', 4:'April', 5:'May', 6:'June', 7:'July', 8:'August', 9:'September', 10:'October', 11:'November', 12:'December'};
            var dths = {1:'Monday', 2:'Tuesday', 3:'Wednesday', 4:'Thursday', 5:'Friday', 6:'Saturday', 7:'Sunday'};
            
            var remaining_month = mths[parseFloat(delivery.getMonth()) + 1];
            var remaining_date = dths[deliveryDay];
            var estimated_day = remaining_date + " " + delivery.getDate().toOrdinal() + " " + remaining_month;
            
            // Update Values and text
            $('#delivery-hour').text(remaining_hours);
            $('#delivery-minute').text(remaining_minutes);

            $('#delivery-day').text(dths[parseFloat(deliveryDay)]);
            $('#delivery-day').append(' '+delivery.getDate().toOrdinal());
            $('#delivery-day').append(' '+mths[parseFloat(delivery.getMonth()) + 1]);

            if(delivery.getFullYear() != todaysDate.getFullYear()){
                $('#delivery-day').append(' '+delivery.getFullYear() );
            }

            $('#delivery-field').val(estimated_day);
            $("#delivery").removeClass("hide");

            if(test){
                console.log("DeliveryHandler > Cutoff Calculated: "+cutOff.toLocaleString("en-GB"));
                console.log("DeliveryHandler > Delivery Calculated: "+delivery.toLocaleString("en-GB"));
            }

        } catch (error) {
            console.log(error);
        }
    },

    runTests(){

        let randomDatesRun = [];

        for(let specialDate of this.specialDates){
            try {
                
                // 2 Tests per run
                for(let x = 0; x < 2; x++){
                    let afterTime = new Date(specialDate.after).getTime();
                    let beforeTime = new Date(specialDate.before).getTime();
                    let randomDate = new Date(afterTime + Math.random() * (beforeTime - afterTime));
                    let dateKey = randomDate.getDay()+"/"+randomDate.getMonth()+"/"+randomDate.getFullYear()+":"+randomDate.getHours();

                    if(randomDatesRun.includes(dateKey)){
                        // Skip alreaady done
                    } else {
                        let year = randomDate.getFullYear();
                        let month = parseInt(randomDate.getMonth()) + 1;
                        let day = randomDate.getDate();
                        let hour = randomDate.getHours();
                        let minutes = randomDate.getMinutes();
                        let seconds = randomDate.getSeconds();
                        this.calculate(true, year, month, day, hour, minutes, seconds);
                        randomDatesRun.push(dateKey);
                    }


                }
                
            } catch (error) {
                console.error(error);
            }
        }
    }
}

deliveryHandler.bind();